export default {"src":"/login-app/[GIT_HASH]/_next/static/media/speed.b5274f07.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};